export default {
  orderList: {
    name2: 'số đơn',
    name3: 'thông tin cơ bản',
    name4: 'tài khoản',
    name5: 'người dùng',
    name6: 'tên thật',
    name7: 'Tên hiển thị',
    name8: 'nền tảng bạn thuộc về',
    name9: 'trò chơi',
    name10: 'phân loại trò chơi',
    name11: 'tên trò chơi',
    name12: 'Thông tin đặt cược',
    name13: 'kỳ cược',
    name14: 'số tiền cược',
    name15: 'số tiền thưởng',
    name16: 'hao hồng tiền thưởng',
    name17: 'Hoàn trả',
    name18: 'tiền thắng thua',
    name19: 'thời gian',
    name20: 'đặt cược',
    name21: 'kết toán',
    name22: 'trạng thái',
    name23: 'thông báo',
    name24: 'thao tác',
    name25: 'chi tiết đơn cược',
    name26: 'tài khoản',
    name27: 'tên tài khoản',
    name28: 'thời gian',
    name29: 'thời gian kết toán',
    name30: 'hoa hồng khuyến mãi',
    name31: 'Tiền hoàn lại',
    status1: 'đã kết toán',
    status2: 'chưa kết toán',
    status3: 'hòa',
    status4: 'khác thường',
    status5: 'hủy đơn',
    status6: 'đóng băng',
    message1: 'Xác nhận thực hiện lệnh hủy đơn chứ',
    message2: 'sao chép thành công',
    message3: 'sao chép thất bại',
    tableTitle: 'Chi tiết cược',
    tableName1: 'Mã số đơn cược',
    tableName2: 'tình trạng đơn cược',
    tableName3: 'kỳ cược',
    tableName4: 'tài khoản',
    tableName5: 'trò chơi',
    tableName6: 'số tiền cược',
    tableName7: 'Thông tin đặt cược',
    tableName8: 'Số tiền thanh toán thực tế',
    tableName9: 'số đặt cược',
    tableName10: 'Thắng cược',
    tableName11: 'Thông tin trúng thưởng',
    tableName12: 'Hoàn trả',
    tableName13: 'Số tiền hoàn trả',
    tableName14: 'Tổng số tiền hoàn lại',
    tableName15: 'số tiền thắng',
    tableName16: 'thắng thua',
    tableName17: 'hao hồng tiền thưởng',
    tableName18: 'thời gian kết toán',
    tableName19: 'thời gian',
    tableName20: 'số mở thưởng',
    tableName21: 'nhiều',
    tableName22: 'Mã đơn',
    tableName23: 'Mã đơn liên quan',
    tableName24: 'Số tiền đặt cược tối thiểu',
    tableName25: 'Số tiền đặt cược tối đa',
    tableName26: 'Số tiền thắng tối thiểu',
    tableName27: 'Số tiền thắng tối đa',
    label01: 'Biến động số dư',
    label02: 'Thời gian',
    label03: 'Loại hình giao dịch',
    label04: 'Số tiền giao dịch',
    label05: 'Mã giao dịch',
    label06: 'Ghi chú',
    label07: 'Truyền tải ID',
    label08: 'Chi tiết đặt hàng',
    label09: 'Lưu ý: Các đơn đặt hàng được giải quyết trong hơn 3 phút',
    label10: 'Lưu ý: Chỉ giữ hồ sơ đặt hàng 24 giờ mới nhất',
    error1: 'Số tiền đặt cược tối thiểu không được phép lớn hơn số tiền đặt cược tối đa',
    error2: 'Số tiền thắng tối thiểu không được phép lớn hơn số tiền thắng tối đa',
    dataDialogName1: '同步订单',
    dataDialogName2: '时间',
    dataDialogName3: '开始时间',
    dataDialogName4: '结束时间',
    dataDialogName5: '所属平台',
    dataDialogName6: '请选择平台',
    dataDialogName7: '用户账户',
    dataDialogName8: '请选择用户',
    dataDialogName9: '一键同步',
    dataDialogName10: '请选择同步时间',
    dataDialogName11: '数据量较大，请耐心等待',
  }
}
